"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoverPortal = void 0;
var react_1 = require("react");
var react_dom_1 = require("react-dom");
var PopoverPortal = function (_a) {
    var container = _a.container, element = _a.element, children = _a.children;
    react_1.useLayoutEffect(function () {
        container.appendChild(element);
        return function () {
            container.removeChild(element);
        };
    }, [container, element]);
    return react_dom_1.createPortal(children, element);
};
exports.PopoverPortal = PopoverPortal;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUG9wb3ZlclBvcnRhbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9Qb3BvdmVyUG9ydGFsLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSwrQkFBK0M7QUFDL0MsdUNBQXlDO0FBT3pDLElBQU0sYUFBYSxHQUFpQyxVQUFDLEVBQWdDO1FBQTlCLFNBQVMsZUFBQSxFQUFFLE9BQU8sYUFBQSxFQUFFLFFBQVEsY0FBQTtJQUNqRix1QkFBZSxDQUFDO1FBQ2QsU0FBUyxDQUFDLFdBQVcsQ0FBQyxPQUFPLENBQUMsQ0FBQztRQUMvQixPQUFPO1lBQ0wsU0FBUyxDQUFDLFdBQVcsQ0FBQyxPQUFPLENBQUMsQ0FBQztRQUNqQyxDQUFDLENBQUM7SUFDSixDQUFDLEVBQUUsQ0FBQyxTQUFTLEVBQUUsT0FBTyxDQUFDLENBQUMsQ0FBQztJQUV6QixPQUFPLHdCQUFZLENBQUMsUUFBUSxFQUFFLE9BQU8sQ0FBQyxDQUFDO0FBQ3pDLENBQUMsQ0FBQztBQUVPLHNDQUFhIn0=